import React, { useEffect, useState } from 'react';
import './SharePanel.css';

const SharePanel = ({ shareId, reviewId = null, label = 'Share PDF' }) => {
  const [copied, setCopied] = useState(false);

  const buildShareUrl = () => {
    const base = `${window.location.origin}${window.location.pathname || '/'}`;
    const params = new URLSearchParams();
    params.set('share', shareId);
    const ctxReviewId =
      typeof reviewId === 'string'
        ? reviewId
        : (reviewId && typeof reviewId === 'object' && reviewId.id ? String(reviewId.id) : null);
    if (ctxReviewId) {
      params.set('shareReviewId', ctxReviewId);
    }
    return `${base}?${params.toString()}`;
  };

  const shareUrl = buildShareUrl();

  useEffect(() => {
    // Debug: helps verify shareReviewId is included when expected.
    console.log('[SharePanel] url built:', { shareId, reviewId, shareUrl });
  }, [shareId, reviewId, shareUrl]);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="share-panel">
      <span className="share-panel-label">{label}</span>
      <div className="share-panel-row">
        <input
          type="text"
          readOnly
          value={shareUrl}
          className="share-url-input"
          aria-label="Share link"
        />
        <button type="button" className="share-copy-btn" onClick={handleCopy}>
          {copied ? '✓ Copied' : 'Copy link'}
        </button>
      </div>
      {copied && (
        <div className="share-tooltip" role="status">
          Link copied to clipboard!
        </div>
      )}
    </div>
  );
};

export default SharePanel;





